import React from 'react';

export class TabBar extends React.Component {
  state = { page: null }

  constructor(props) {
    super(props);

    const { items } = this.props;
    let page = '';

    if (items != null && items.length > 0) {
      page = items[0][0];
    }

    this.state = { page };
  }

  reset = () => {
    const { items } = this.props;

    if (items && items.length) {
      this.setState({ page: items[0][0] });
      this.onTabChange(items[0][0])
    }
  }

  onTabClick = (ev) => {
    const page = ev.target.getAttribute('data-page');

    this.onTabChange(page)
  }

  onTabChange = (page) => {
    const { onChange } = this.props;
    this.setState({page});

    if (onChange)
      onChange(page);
  }

  render() {
    const {items = []} = this.props;
    const { page } = this.state;

    return (
      <div className="auth__tabs">
        {items.map((item, index) => (
          <div key={index} className={`auth__tab ${page === item[0] && 'active'}`}>
            <a className="auth__tab-link is-clickable" data-page={item[0]} onClick={this.onTabClick}>
              {item[1]}
            </a>
          </div>
        ))}
      </div>
    );
  }
};
